import { where } from "firebase/firestore";
import { subscribeToCol } from "@/composables/events/handler";

let commitFn = null;

function handleDoc(docData) {
	commitFn("setEmailGroupState", docData);
	commitFn("setGroupNewEmails", {});
}

function loadDocs(snapshot) {
	snapshot?.docs?.forEach(doc => {
		if (doc.exists()) {
			handleDoc(doc.data());
		}
	});
}

export function subscribe(userGroupId) {
	console.log("[EMAIL-GROUPS-STATE] Subscribing to userGroup:", userGroupId);

	try {
		subscribeToCol("email-groups-state", [
			where("groupId", "==", userGroupId)
		], {
			onInitialLoad: loadDocs,
			onAdded: handleDoc,
			onUpdated: handleDoc,
			onUnsubscribed: () => {
				console.log("[EMAIL-GROUPS-STATE] Unsubscribed from email groups state");
			},
			onError: (error) => {
				console.error("[EMAIL-GROUPS-STATE-EVENTS] Subscription error:", {
					code: error.code,
					message: error.message
				});
			}
		});
	} catch (err) {
		console.error("[EMAIL-GROUPS-STATE-EVENTS] Failed to subscribe:", err);
		throw err;
	}
}

export function init(commit) {
	commitFn = commit;
}
